import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';

import { switchMap, map, catchError, of, exhaustMap } from 'rxjs';
import { TranslationsActions } from '../actions/translations.actions';
import { TranslationsService } from '../service/translations.service';
import { Action } from '@ngrx/store';

@Injectable()
export class TranslationsEffects implements OnInitEffects {
  loadTranslationsStores$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TranslationsActions.loadTranslationbyType),
      switchMap(({ translationType }) => {
        const translationStream =
          this.translationsService.fetchTranslationsByType(translationType);
        return translationStream.pipe(
          map((translation) => {
            return TranslationsActions.translationLoadedSuccess({
              translation,
            });
          }),
          catchError((error) =>
            of(
              TranslationsActions.translationLoadedFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    );
  });

  loadTranslationsForSex$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationsActions.loadInitalTranslations),
      exhaustMap(() => {
        const translationStream =
          this.translationsService.fetchTranslationsByType('sex');
        return translationStream.pipe(
          map((translation) => {
            return TranslationsActions.translationLoadedSuccess({
              translation,
            });
          }),
          catchError((error) =>
            of(
              TranslationsActions.translationLoadedFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    )
  );

  loadTranslationsForBreeds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationsActions.loadInitalTranslations),
      exhaustMap(() => {
        const translationStream =
          this.translationsService.fetchTranslationsByType('breeds');
        return translationStream.pipe(
          map((translation) => {
            return TranslationsActions.translationLoadedSuccess({
              translation,
            });
          }),
          catchError((error) =>
            of(
              TranslationsActions.translationLoadedFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    )
  );

  loadTranslationsForColor$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationsActions.loadInitalTranslations),
      exhaustMap(() => {
        const translationStream =
          this.translationsService.fetchTranslationsByType('color');
        return translationStream.pipe(
          map((translation) => {
            return TranslationsActions.translationLoadedSuccess({
              translation,
            });
          }),
          catchError((error) =>
            of(
              TranslationsActions.translationLoadedFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    )
  );

  loadTranslationsForDiscipline$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationsActions.loadInitalTranslations),
      exhaustMap(() => {
        const translationStream =
          this.translationsService.fetchTranslationsByType('discipline');
        return translationStream.pipe(
          map((translation) => {
            return TranslationsActions.translationLoadedSuccess({
              translation,
            });
          }),
          catchError((error) =>
            of(
              TranslationsActions.translationLoadedFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private translationsService: TranslationsService
  ) {}

  ngrxOnInitEffects(): Action {
    return TranslationsActions.loadInitalTranslations();
  }
}
